declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

/**
 * Docs: https://aha-move.atlassian.net/wiki/spaces/ahaai/pages/4263477328/AF-02+Log+2+button+t+ngay+Chat+t+m+n
 */
export type EventTrackingType =
  | 'click_button' //
  | 'check_fb_log_in' //
  | 'fb_log_in_success' // Khi user đã đăng nhập thành công vào Facebook Messenger (và theo dõi thêm như có lấy được fb_id hay không).
  | 'chatbot_event'
  | 'order_event'
  | 'search_event';

const shouldTrackEvent = () => {
  return process.env.NEXT_PUBLIC_ENABLE_TRACKING_EVENT === 'true';
};

export const trackEvent = (
  eventType: EventTrackingType,
  eventParameters: Record<string, any> = {}
) => {
  try {
    // Check if running in a browser environment
    if (window?.dataLayer && shouldTrackEvent()) {
      console.log('[Tracked]', eventType, eventParameters);
      window.dataLayer.push({
        event: 'custom_event',
        eventType,
        ...eventParameters,
      });
    } else {
      console.log('[Not Tracked]', eventType, eventParameters);
    }
  } catch (error) {
    console.log('TRACKING ERROR: ', error);
  }
};
